import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "nav",
  ref: "navEl"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "nav-grid" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "login-nav"
}
const _hoisted_6 = {
  key: 1,
  class: "loggedIn"
}
const _hoisted_7 = { class: "loggedIn-grid" }
const _hoisted_8 = { class: "flex link-nav" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "account-bubble"
}
const _hoisted_11 = { class: "account-bubble-inner" }
const _hoisted_12 = {
  key: 2,
  class: "search-wrapper"
}
const _hoisted_13 = {
  key: 0,
  class: "menu"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "quick-links"
}
const _hoisted_16 = { class: "quick-links-container" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_searchBar = _resolveComponent("searchBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            class: "logo",
            to: _ctx.logoUrl
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.branding.logo,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["to"]),
          (!_ctx.isAuthenticated && !_ctx.hideLogNowSignin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_RouterLink, {
                  class: "signin-btn",
                  to: "/signin",
                  onClick: _ctx.login
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Sign In", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _cache[13] || (_cache[13] = _createElementVNode("p", null, "/", -1)),
                _createVNode(_component_RouterLink, {
                  class: "signin-btn",
                  to: "/join",
                  onClick: _ctx.login
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Join Now", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_RouterLink, {
                      class: "signin-btn",
                      to: "/collect-home"
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("Collect Points", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[16] || (_cache[16] = _createElementVNode("p", null, "|", -1)),
                    _createVNode(_component_RouterLink, {
                      class: "signin-btn",
                      to: "/spend"
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("Spend Points", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: "my-profile-wrapper",
                    onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAccountMenu = true)),
                    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAccountMenu = false))
                  }, [
                    _createVNode(_component_RouterLink, {
                      to: "/my-account",
                      class: "my-profile"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "profileIcon",
                          src: _ctx.profileIcon
                        }, null, 8, _hoisted_9)
                      ]),
                      _: 1
                    }),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (_ctx.showAccountMenu)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_RouterLink, {
                                  to: "/statement",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAccountMenu = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                    _createTextVNode("Account Statement", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_RouterLink, {
                                  to: "/my-profile",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAccountMenu = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                    _createTextVNode("My Profile", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_RouterLink, {
                                  to: "/help-centre",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAccountMenu = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("Help Centre", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_RouterLink, {
                                  to: "/contact-preferences",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAccountMenu = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("Contact Preferences", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)), ["prevent"]))
                                }, "Log Out")
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 32),
                  _createElementVNode("div", {
                    class: "burger-menu",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ open: _ctx.isOpen })
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass({ open: _ctx.isOpen })
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass({ open: _ctx.isOpen })
                    }, null, 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_searchBar)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: "/collect-home",
                  onClick: _ctx.closeMenu
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("Collect Points", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: "/spend",
                  onClick: _ctx.closeMenu
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Spend Points", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quicklinks, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.url
                }, [
                  (item.url.startsWith('http://') || item.url.startsWith('https://'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                      }, _toDisplayString(item.title), 9, _hoisted_14))
                    : (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 1,
                        to: item.url,
                        onClick: _ctx.closeMenu
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "onClick"]))
                ]))
              }), 128)),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)), ["prevent"]))
                }, "Log Out")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quicklinks, (quicklink, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: quicklink.url
              }, [
                (quicklink.url.startsWith('http://') || quicklink.url.startsWith('https://'))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: quicklink.url,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(quicklink.title), 9, _hoisted_17))
                  : (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 1,
                      to: quicklink.url
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(quicklink.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])),
                (index < _ctx.quicklinks.length - 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "|"))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}